import React from 'react'
import { useNavigate } from 'react-router-dom'
import { RouteConstants } from '../../Constants/routeConstants'
import './AboutUs.scss'

const AboutUs: React.FC = () => {
  const navigate = useNavigate()
  const d = new Date()
  const year = d.getFullYear()

  return (
    <div className="about-us-container">
      <div className="about-us-content">
        <div className="hero-section">
          <h1 className="main-title">"Why LivingLegacy.me"</h1>
          <p className="subtitle">A New Name. The Same Mission. Even More Life.</p>
        </div>

        <div className="content-section">
          <p className="intro-text">
            When we began building this platform, our mission was clear: to help people preserve their stories, memories, beliefs, and values—forever. At first, we launched our idea under the name Legacy.me, a name that reflected the heart of our vision: a digital space where your life story could live on. But as we grew, we realized that our vision wasn't just about legacy. It was about living.
          </p>

          <div className="section">
            <h2 className="section-title">Why We Changed Our Name</h2>
            <p>
              While Legacy.me captured part of who we are, it also shared similarities with another well-known memorial site focused on obituaries and death notices. To avoid confusion and reflect the true spirit of what we're building, we made the decision—on the advice of our legal counsel—to evolve our brand to something even more fitting:
            </p>
            <div className="highlight-box">
              <h3>🎉 LivingLegacy.me</h3>
              <p>A place to preserve the story of your life, while you're still here to tell it.</p>
            </div>
          </div>

          <div className="section">
            <h2 className="section-title">What LivingLegacy.me Stands For</h2>
            <div className="values-grid">
              <div className="value-item">
                <h3>• Living</h3>
                <p>— because your story isn't over. You're still creating it, moment by moment.</p>
              </div>
              <div className="value-item">
                <h3>• Legacy</h3>
                <p>— because your experiences, lessons, and values deserve to be remembered.</p>
              </div>
              <div className="value-item">
                <h3>• .me</h3>
                <p>— because it's personal. Your voice. Your memories. Your timeline.</p>
              </div>
            </div>
            <p className="belief-text">
              We believe in celebrating life, not just memorializing it. LivingLegacy.me is where you can upload photos and videos, answer meaningful questions, and leave behind a living time capsule for future generations.
            </p>
          </div>

          <div className="section">
            <h2 className="section-title">The Future Is Personal</h2>
            <p>
              This is more than a name change. It's a deepened commitment to helping you shape how you're remembered—on your terms, in your own words. We're proud to welcome you to LivingLegacy.me. Because the legacy you leave tomorrow starts with the life you live today.
            </p>
          </div>

          <div className="contact-section">
            <h2 className="section-title">💬 Questions?</h2>
            <p>We're always here to chat.</p>
            <div className="cta-buttons">
              <button className="cta-button primary">Contact Us</button>
              <button className="cta-button secondary">Explore the Platform</button>
            </div>
          </div>
        </div>
      </div>
      
      <div id="PreFooter">
        <div className="content">
          <h3>Create a Legacy in Minutes</h3>
          <button
            onClick={() => {
              navigate('/search')
            }}
            type="button"
            className="getStarted"
          >
            SEARCH
          </button>
        </div>
      </div>
      
      <footer className="Footer">
        <div className="container">
          <ul>
            <li>
              <a target="_blank" href={RouteConstants.TERMCONDITION} rel="noreferrer">
                Terms of Service
              </a>
            </li>
            <li>
              <a target="_blank" href={RouteConstants.PRIVACYPOLICY} rel="noreferrer">
                Privacy Policy
              </a>
            </li>
            <li>© {year} Living Legacy Co. All rights reserved</li>
          </ul>
          <p
            className="hidden-link"
            onClick={() => {
              navigate(RouteConstants.PUBLICPAGES)
            }}
          >
            Pages
          </p>
        </div>
      </footer>
    </div>
  )
}

export default AboutUs 